var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E550FB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -95) translate(17 95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.207 7.984H1.747C.788 7.984 0 8.773 0 9.731v12.476c0 .958.788 1.746 1.747 1.746h20.46c.958 0 1.746-.788 1.746-1.746V9.73c0-.958-.788-1.747-1.746-1.747zm-1.248 4.741v6.487c0 .959-.778 1.747-1.747 1.747h-5.489c-.968 0-1.746-.788-1.746-1.747v-6.487c0-.958.778-1.746 1.746-1.746h5.49c.968 0 1.746.788 1.746 1.746zM9.232 16.468h-5.49c-.408 0-.748-.34-.748-.749s.34-.748.749-.748h5.489c.41 0 .749.34.749.748 0 .41-.34.749-.749.749zm.749 2.245c0 .41-.34.749-.749.749h-5.49c-.408 0-.748-.34-.748-.749s.34-.748.749-.748h5.489c.41 0 .749.34.749.748zm-.749-5.24h-5.49c-.408 0-.748-.339-.748-.748s.34-.748.749-.748h5.489c.41 0 .749.339.749.748 0 .41-.34.749-.749.749zM22.207 0H9.73c-.963 0-1.747.783-1.747 1.747v2.495c0 .963.784 1.746 1.747 1.746h12.476c.963 0 1.746-.783 1.746-1.746V1.747C23.953.783 23.17 0 22.207 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.994,
    cy: 2.994,
    r: 2.994
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.bd8ca755.svg";
export { ForwardRef as ReactComponent };